//@ts-nocheck

export const BorderAnimate = async () => {
  animateBorder();
};

function animateBorder() {
  gsap.registerPlugin(ScrollTrigger);

  gsap.utils.toArray(".animateBorder").forEach((section, i) => {
    gsap.to(section, {
      scrollTrigger: {
        trigger: section,
        start: "center 80%",
        end: "center 10%",
        onEnter: () => section.classList.add("animate"),
        // markers: true,
        id: `borde${i}`,
      },
    });
  });
}
